// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"style_homeContainer__JCuhe","centerContent":"style_centerContent__TDPzE","commonSidebar":"style_commonSidebar__flstl"};